/**
 * ```typescript
 * unionOfSets(new Set([1, 2]), new Set([2, 3])); //=> new Set([1, 2, 3, 4])
 * ```
 */
export function unionOfSets(set1: any, set2: any): Set<any> {
  return new Set([...set1, ...set2]);
}
